<!-- 实验历史总页面 -->
<template>
  <v-card color="green" dark>
    <v-card-title>
      <span class="font-weight-black ml-3"> 实验历史</span>
      <v-spacer></v-spacer>
      <div style="width:280px">
        <v-text-field
          dense
          solo
          light
          class="ma-0 pa-0 text-body-2"
          append-icon="mdi-calendar-search"
          hide-details
          placeholder="关键字搜索实验"
        >
        </v-text-field>
      </div>
    </v-card-title>
    <v-card-text class="mt-0 pt-0">
      <v-card color="white" light height="860">
        <v-card-text>
          <v-row>
            <!-- 左侧列表 -->
            <v-col cols="3" class="pa-0">
              <index-list @selected="selected" />
            </v-col>
            <!-- 右侧详细 -->
            <v-col cols="9">
              <detail :experiment="experiment" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>
<script>
import IndexList from './HistoryIndexList.vue'
import Detail from './HistoryDetail.vue'
export default {
  components: { IndexList, Detail },
  data() {
    return {
      experiment: undefined
    }
  },
  mounted() {},
  methods: {
    selected(experiment) {
      this.experiment = experiment
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/history/index.vue